import { useSelector } from 'react-redux'

import MultiBarCard from '../../../components/ReusableComponents/Charts/Inslghts/MultiBar/index'
import { ReactComponent as NightIcon } from './night.svg'
import styles from './ReservationLength.module.scss'

const ReservationLength = () => {
  const reservationLengthBreakdown = useSelector(
    s => s.insights.reservationLengthInsights.thisYear
  )

  const averageNights = useSelector(
    s => s.insights.reservationLengthInsights.averageNights
  )

  if (!reservationLengthBreakdown) {
    return null
  }

  if (averageNights.length < 3) {
    return null
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.cardInner}>
            <div className={styles.title}>
              Average reservation length in{' '}
              {averageNights[averageNights.length - 2].checkOutYear}
            </div>
            <div className={styles.big}>
              {averageNights[averageNights.length - 2].averageNights.toFixed(2)} nights
            </div>
          </div>
          <div className={styles.cardFooter}>
            {averageNights.slice(0, averageNights.length - 2).map(o => (
              <div className={styles.extraStat} key={o.checkOutYear}>
                <NightIcon />
                {o.averageNights.toFixed(2)} nights in {o.checkOutYear}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.barHolder}>
          <MultiBarCard
            barSize={20}
            title="Reservation length breakdown"
            subtitle={`For ${new Date().getFullYear() - 1}`}
            data={reservationLengthBreakdown.filter(
              o => !['31-60', '61+'].includes(o.name)
            )}
            height={220}
            yLabel="guests"
            unit="nights"
          />
        </div>
      </div>
    </>
  )
}

export default ReservationLength
